module.exports = __webpack_public_path__ + "static/img/TBW.1acf1579.svg";